<template>
  <div class="comment-utility-button">
    <v-menu offset-y transition="slide-y-transition">
      <template #activator="{ on, attrs }">
        <button v-bind="attrs" v-on="on">
          <v-icon :size="size">mdi-dots-horizontal</v-icon>
        </button>
      </template>

      <v-list class="utility-menu">
        <v-list-item v-if="userHasDeletePrivileges" @click="startDeleteComment(comment.id)"> Delete </v-list-item>

        <v-list-item v-if="comment.author.username !== username" @click="reportComment(comment.id)">
          <span class="red--text">Report</span>
        </v-list-item>

        <v-list-item> Cancel </v-list-item>
      </v-list>
    </v-menu>

    <!-- dialog pop ups -->
    <v-dialog v-model="deleteComment.dialog">
      <v-card>
        <v-card-title>Are you sure you want to delete?</v-card-title>
        <v-card-actions>
          <v-btn @click="deleteComment.dialog = false" color="primary"> No </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="confirmDeleteComment" color="red"> Yes </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "comment-utility-button.vue",

  props: {
    size: Number,
    comment: {},
    review: {},
  },

  computed: {
    username() {
      return this.$store.state.username;
    },

    userHasDeletePrivileges() {
      return this.comment.author.username === this.username || this.review.author.username === this.username;
    },
  },

  data: function () {
    return {
      report: {
        id: -1,
        dialog: false,
      },
      deleteComment: {
        id: -1,
        dialog: false,
      },
    };
  },

  methods: {
    ...mapMutations(["showSnackbar", "showReportPopup"]),

    reportComment: function (id) {
      this.showReportPopup({
        contentId: id,
        contentType: "comment",
      });
    },

    startDeleteComment: function (id) {
      this.deleteComment.dialog = true;
      this.deleteComment.id = id;
    },

    confirmDeleteComment: function () {
      this.$axios
        .delete("/comment", {
          params: {
            id: this.deleteComment.id,
          },
        })
        .then(() => {
          this.deleteComment.dialog = false;
          this.$root.$emit("delete-comment", this.comment);
        })
        .finally(() => {
          this.deleteComment.id = undefined;
        });
    },
  },
};
</script>

<style scoped>
.comment-utility-button {
  display: inline-block;
}
</style>
